/** Count leave days as calendar days, inclusive of both start and end. */
export function countLeaveDays(startDate: string, endDate: string): number {
  const start = new Date(startDate.slice(0, 10));
  const end = new Date(endDate.slice(0, 10));
  start.setHours(0, 0, 0, 0);
  end.setHours(0, 0, 0, 0);
  if (end < start) return 0;
  const dayMs = 24 * 60 * 60 * 1000;
  return Math.round((end.getTime() - start.getTime()) / dayMs) + 1;
}
